import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("login.errors.invalid")
    .required("login.errors.required"),
  password: yup.string().required("login.errors.required"),
});

export const registerSchema = yup.object().shape({
  firstName: yup.string().required("register.errors.required"),
  lastName: yup.string().required("register.errors.required"),
  email: yup
    .string()
    .email("register.errors.invalidEmail")
    .required("register.errors.required"),
  password: yup
    .string()
    .min(8, "register.errors.passwordMin")
    .required("register.errors.required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "register.errors.passwordMismatch")
    .required("register.errors.required"),
});
